import { useEffect } from 'react';
import { FONT_LIBRARY, getFontCssUrl } from '@/lib/fontOptions';

export const useDynamicFont = (fontNames: (string | undefined)[]) => {
  useEffect(() => {
    fontNames.forEach((fontName) => {
      if (!fontName) return;
      
      const linkId = `dynamic-font-${fontName.replace(/\s+/g, '-')}`;
      
      // Evitar duplicatas
      if (document.getElementById(linkId)) return;
      
      // Check if font is in library, otherwise try Google Fonts
      const cssUrl = FONT_LIBRARY[fontName] 
        ? getFontCssUrl(fontName)
        : `https://fonts.googleapis.com/css2?family=${fontName.replace(/\s+/g, '+')}:wght@400;500;700&display=swap`;
      
      if (!cssUrl) return;
      
      const link = document.createElement('link');
      link.id = linkId;
      link.rel = 'stylesheet';
      link.href = cssUrl;
      document.head.appendChild(link);
    });
  }, [fontNames]);
};
